import { createTranslations } from '@npco/common-utils-translations'

export const setupFlowDownloadMessageTranslations = createTranslations({
  downloadMessage:
    'To download, scan the QR code or visit the {appStore} or {googlePlay}.',
  downloadMessageAppStore:
    'To download, scan the QR code or visit the {appStore}.',
  mobileDownloadMessage: 'Tap to download Zeller App today.',
})
